export type FormattedValue =
  | { kind: 'text'; text: string }
  | { kind: 'metric'; amount: string; unit: string }
  | { kind: 'datetime'; date: string; time: string };

// Getal aan het begin (Nederlandse notatie: 10.000 of 12,5), daarna optioneel
// een spatie en de rest als eenheid.
const LEADING_NUMBER = /^(-?\d{1,3}(?:\.\d{3})+(?:,\d+)?|-?\d+(?:,\d+)?)(?:\s+([\s\S]*))?$/;
// Exact dd/mm/jjjj uu:mm, optioneel gevolgd door "uur".
const DATE_TIME = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})(?:\s*uur)?$/;

const dateFormat = new Intl.DateTimeFormat('nl-NL', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Leidt de weergavevorm af uit het datatype van het criterium en de tekst zelf.
 * Past de tekst niet in de verwachte vorm, dan blijft het de ruwe tekst — de
 * waarde wordt nooit omgerekend of samengevat.
 */
export function formatValue(value: string, criterionType: string | null): FormattedValue {
  const text = value.trim();

  if (criterionType === 'number') {
    const match = text.match(LEADING_NUMBER);
    if (match) return { kind: 'metric', amount: match[1]!, unit: match[2] ?? '' };
  }

  if (criterionType === 'datetime') {
    const match = text.match(DATE_TIME);
    if (match) {
      const [, dd, mm, yyyy, hh, min] = match;
      const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      const isRealDate = date.getDate() === Number(dd) && date.getMonth() === Number(mm) - 1;
      if (isRealDate) {
        return { kind: 'datetime', date: capitalize(dateFormat.format(date)), time: `${hh}:${min}` };
      }
    }
  }

  return { kind: 'text', text };
}
